import { render, staticRenderFns } from "./MarketInsights.vue?vue&type=template&id=0bb52748&"
import script from "./MarketInsights.vue?vue&type=script&lang=js&"
export * from "./MarketInsights.vue?vue&type=script&lang=js&"
import style0 from "./MarketInsights.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports